import React, { useEffect, useState } from 'react';
import { ControlCol, ControlRow2, CustomInput, ThreeControlRow } from './costing-page';
import { Col, FlexboxGrid, Panel, Row, SelectPicker, Stack } from 'rsuite';
import axios from 'axios';
import globalIP from '@/GlobelIP';
import { Width } from '@rsuite/icons';

export const BottomLeftSection = React.memo(
  ({
    handleFieldDataValue,
    fieldData,
    setReload,
    setReload2,
    showTables,
    setUpdatingCalc,
    handleReload,
    handleFieldUpdate,
    updatingCalc,
    setCostingheads,
    costingheads,
    totalCBMperpc,
    selectedcurr,
    setSelectedCurr,
    currencydata,
    setCurrencydata
  }) => {
    // Fetch data from API on mount

    // useEffect(() => {
    //   console.log('totalCBMperpc', totalCBMperpc);
    // }, [totalCBMperpc])

    useEffect(() => {
      const cur = currencydata.find(item => {
        // console.log("item.id == fieldData.currencyLabel")
        // console.log(item.id, fieldData.currencyLabel)
        return item.id == +fieldData.currencyLabel;
      });
      setSelectedCurr(cur);
    }, [fieldData.currencyLabel, currencydata]);

    useEffect(() => {
      // console.log('selectedcurr', selectedcurr);
    }, [selectedcurr]);
    useEffect(() => {
      fetchDatacurr();
    }, []);

    const fetchDatacurr = async () => {
      try {
        const response = await fetch(`${globalIP}/api/currency-masters`);
        const json = await response.json();

        const currency = json.data.map(item => ({
          id: item.id,
          label: item.attributes.currencyname, // Setting label
          value: item.attributes.currencyname, // Setting value
          exchangerate: item.attributes.exchangerate
        }));
        setCurrencydata(currency);
      } catch (error) {
        console.error('Error fetching currency data:', error);
      }
    };

    return (
      <Col xs={24}>
        <Panel
          style={{
            boxShadow: '0px 0px 4px -1px grey',
            borderRadius: '6px',
            marginBottom: '10px',
            width: '99.8%',
            marginLeft: '-15px'
          }}
        >
          <Row gutter={20}>
            <Col xs={12}>
              <Stack
                direction="column"
                justifyContent="space-between"
                alignItems="normal"
                spacing={5}
              >
                <ControlRow2
                  label="Product Cost"
                  // label="OverAllCost"
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      placeholder="0.00"
                      name="overAllCost"
                      value={fieldData?.overallcost.toFixed(2)}
                    />
                  }
                />
                <ThreeControlRow
                  label="Profit % "
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      value={`${
                        updatingCalc?.Profitper
                          ? fieldData.profitper
                          : fieldData.profitper.toFixed(2)
                      }`}
                      onChange={value => {
                        const total = fieldData?.overallcost;
                        const profit = (+total * +value) / 1 / 100;
                        const targetCost = profit + +total;
                        const profitRupee = (targetCost - total) / 1;
                        handleFieldDataValue('profitper', value / 1);
                        // handleFieldDataValue('targetCost', targetCost);
                        handleFieldDataValue('profitcost', profitRupee.toFixed(2));
                        setReload(prev => !prev);
                      }}
                      onFocus={() => {
                        handleFieldUpdate('Profitper', true);
                      }}
                      onBlur={() => handleFieldUpdate('Profitper', false)}
                    />
                  }
                  control2={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      value={`${
                        updatingCalc?.Profitcost
                          ? fieldData.profitcost
                          : (fieldData.profitcost / 1).toFixed(2)
                      }`}
                      onChange={value => {
                        const total = fieldData?.overallcost;
                        const profitper = (+value / total) * 100;
                        handleFieldDataValue('profitper', +profitper);
                        // handleFieldDataValue('targetCost', targetCost);
                        handleFieldDataValue('profitcost', +value);
                        setReload(prev => !prev);
                      }}
                      onFocus={() => {
                        handleFieldUpdate('Profitcost', true);
                      }}
                      onBlur={() => handleFieldUpdate('Profitcost', false)}
                    />
                  }
                />
                <ControlRow2
                  // label="Wiring Cost"
                  label="Accessories Cost"
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      placeholder="0.00"
                      name="wiringcost"
                      value={
                        String(
                          updatingCalc?.Wiring
                            ? Number(fieldData.wiringcost)
                            : (fieldData?.wiringcost || 0).toFixed(2)
                        ) || '0.00'
                      }
                      // value={String(fieldData.fittingcost) || 0}
                      disabled={showTables.accessories}
                      onChange={value => {
                        handleFieldDataValue('wiringcost', value / 1);

                        setReload2(prev => !prev);
                      }}
                      onFocus={() => {
                        handleFieldUpdate('Wiring', true);
                      }}
                      onBlur={() => handleFieldUpdate('Wiring', false)}
                    />
                  }
                />
                <ControlRow2
                  label="Process Cost"
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      placeholder="0.00"
                      name="processcost"
                      value={
                        String(
                          updatingCalc?.ProcessCost
                            ? Number(fieldData.processcost)
                            : (fieldData?.processcost || 0).toFixed(2)
                        ) || '0.00'
                      }
                      disabled={showTables.process}
                      onChange={value => {
                        handleFieldDataValue('processcost', value / 1);

                        if (showTables.process) {
                          setReload(prev => !prev);
                        } else {
                          setReload2(prev => !prev);
                        }
                      }}
                      onFocus={() => {
                        handleFieldUpdate('ProcessCost', true);
                      }}
                      onBlur={() => {
                        handleFieldUpdate('ProcessCost', false);
                      }}
                    />
                  }
                />

                <ControlRow2
                  label="Packing Cost"
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      placeholder="0.00"
                      name="packingcost"
                      value={
                        String(
                          updatingCalc?.Packing
                            ? Number(fieldData.packingcost)
                            : (fieldData?.packingcost || 0).toFixed(2)
                        ) || '0.00'
                      }
                      // value={String(fieldData.packingcost) || 0}
                      disabled={showTables.packing}
                      onChange={value => {
                        handleFieldDataValue('packingcost', value / 1);

                        if (showTables.packing) {
                          setReload(prev => !prev);
                        } else {
                          setReload2(prev => !prev);
                        }
                      }}
                      onFocus={() => {
                        handleFieldUpdate('Packing', true);
                      }}
                      onBlur={() => handleFieldUpdate('Packing', false)}
                    />
                  }
                />
                <ControlRow2
                  label="Extra Packing Cost"
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      placeholder="0.00"
                      name="fittingcost"
                      value={
                        String(
                          updatingCalc?.Fitting
                            ? Number(fieldData.fittingcost)
                            : (fieldData?.fittingcost || 0).toFixed(2)
                        ) || '0.00'
                      }
                      // value={String(fieldData.fittingcost) || 0}
                      onChange={value => {
                        handleFieldDataValue('fittingcost', value / 1);
                        if (
                          showTables.accessories ||
                          showTables.packing ||
                          showTables.material ||
                          showTables.wood ||
                          showTables.process
                        ) {
                          setReload(prev => !prev);
                        } else {
                          setReload2(prev => !prev);
                        }
                      }}
                      onFocus={() => {
                        handleFieldUpdate('Fitting', true);
                      }}
                      onBlur={() => handleFieldUpdate('Fitting', false)}
                    />
                  }
                />
                <ThreeControlRow
                  label="Shipping Cost"
                  control={
                    <FlexboxGrid style={{ flexWrap: 'nowrap' }}>
                      <CustomInput id="custinputno" name="CbmPcs" value={totalCBMperpc} />
                      <CustomInput
                        id="custinputno"
                        name="FOB"
                        value={
                          updatingCalc?.FOB ? costingheads?.FOB : (+costingheads?.FOB).toFixed(2)
                        }
                        onChange={value => {
                          setCostingheads(prev => ({
                            ...prev,
                            FOB: +value
                          }));
                          handleReload();
                        }}
                        onFocus={() => {
                          handleFieldUpdate('FOB', true);
                        }}
                        onBlur={() => handleFieldUpdate('FOB', false)}
                      />
                    </FlexboxGrid>
                  }
                  control2={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      placeholder="0.00"
                      // value={fieldData?.shippingcost}
                      value={
                        updatingCalc?.Shipping
                          ? fieldData.shippingcost
                          : fieldData.shippingcost.toFixed(2)
                      }
                      onChange={value => {
                        handleFieldDataValue('shippingcost', value / 1);
                        handleReload();
                      }}
                      onFocus={() => {
                        handleFieldUpdate('Shipping', true);
                      }}
                      onBlur={() => handleFieldUpdate('Shipping', false)}
                    />
                  }
                />
                <ControlRow2
                  label={<strong>Total Product Cost</strong>}
                  control={
                    <CustomInput id="custinputno2" value={fieldData?.subtotalcost.toFixed(2)} />
                  }
                />
                <ThreeControlRow
                  label="OverHead %"
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      name="overheadper"
                      value={
                        updatingCalc?.OverHeadPer
                          ? fieldData.overheadper
                          : (fieldData.overheadper / 1).toFixed(2) || 0.0
                      }
                      // value={fieldData.overheadper}
                      onChange={value => {
                        const result = (+fieldData.subtotalcost * +value) / 100;
                        handleFieldDataValue('overheadper', value || 0);
                        handleFieldDataValue('overheadcost', result.toFixed(2) || 0);
                        handleReload();
                      }}
                      onFocus={() => {
                        handleFieldUpdate('OverHeadPer', true);
                      }}
                      onBlur={() => handleFieldUpdate('OverHeadPer', false)}
                    />
                  }
                  control2={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      name="overheadcost"
                      value={
                        updatingCalc?.OverHeadCost
                          ? fieldData.overheadcost
                          : (fieldData.overheadcost / 1).toFixed(2) || 0.0
                      }
                      onChange={value => {
                        const percentage = (+value / +fieldData.subtotalcost) * 100;
                        handleFieldDataValue('overheadcost', value);
                        handleFieldDataValue('overheadper', percentage.toFixed(2));
                        handleReload();
                      }}
                      onFocus={() => {
                        handleFieldUpdate('OverHeadCost', true);
                      }}
                      onBlur={() => handleFieldUpdate('OverHeadCost', false)}
                    />
                  }
                />
                <ControlRow2
                  label={<strong>{'Final Costing (INR)'} </strong>}
                  control={
                    <CustomInput
                      id="custinputno2"
                      name="subtotalwohcost"
                      value={fieldData.subtotalwohcost.toFixed(2)}
                    />
                  }
                />

                <ThreeControlRow
                  label={`Curr./Ex-Rate/Rate`}
                  control={
                    <FlexboxGrid style={{ flexWrap: 'nowrap' }}>
                      <SelectPicker
                        data={currencydata}
                        cleanable={false}
                        placeholder="Currency"
                        size="xs"
                        placement="auto"
                        // labelKey="label"
                        // valueKey="value"
                        container={() => document.getElementById('custom-container')}
                        value={selectedcurr?.value}
                        onChange={value => {
                          if (
                            showTables.accessories ||
                            showTables.packing ||
                            showTables.material ||
                            showTables.wood ||
                            showTables.process
                          ) {
                            setReload(prev => !prev);
                          } else {
                            setReload2(prev => !prev);
                          }
                          const cur = currencydata.find(item => item.value == value);
                          setSelectedCurr(cur);
                          const exrate = cur.exchangerate;
                          console.log('exrate', exrate);
                          console.log('cur', cur);
                          handleFieldDataValue('currencyRate', exrate);
                          handleFieldDataValue('currencyLabel', `${cur.id}`);
                        }}
                        onOpen={fetchDatacurr}
                      />
                      <CustomInput
                        step={null}
                        id="custinputno"
                        value={String(fieldData?.currencyRate) || ''}
                        onChange={value => {
                          if (
                            showTables.accessories ||
                            showTables.packing ||
                            showTables.material ||
                            showTables.wood ||
                            showTables.process
                          ) {
                            setReload(prev => !prev);
                          } else {
                            setReload2(prev => !prev);
                          }
                          handleFieldDataValue('currencyRate', value);
                        }}
                      />
                    </FlexboxGrid>
                  }
                  control2={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      value={(fieldData?.targetcostUSD / 1).toFixed(2)}
                    />
                  }
                ></ThreeControlRow>

                {/* <ControlCol
                    label="Cur Rate"
                    control={
                      <CustomInput
                        step={null}
                        value={String(fieldData?.currencyRate) || ''}
                        onChange={value => {
                          if (
                            showTables.accessories ||
                            showTables.packing ||
                            showTables.material ||
                            showTables.wood ||
                            showTables.process
                          ) {
                            setReload(prev => !prev);
                          } else {
                            setReload2(prev => !prev);
                          }
                          handleFieldDataValue('currencyRate', value);
                        }}
                      />
                    }
                  /> */}
                {/* <ControlCol
                    label="INR"
                    control={
                      <CustomInput
                        step={null}
                        value={fieldData?.targetCost}
                        onChange={value => {
                          if (
                            showTables.accessories ||
                            showTables.packing ||
                            showTables.material ||
                            showTables.wood ||
                            showTables.process
                          ) {
                            setReload(prev => !prev);
                          } else {
                            setReload2(prev => !prev);
                          }
                          handleFieldDataValue('targetCost', value);
                        }}
                      />
                    }
                  /> */}
                {/* <ControlCol
                    label="USD"
                    control={<CustomInput step={null} value={fieldData?.targetcostUSD} />}
                  /> */}
              </Stack>
            </Col>
            <Col xs={6} style={{ marginBottom: '15px' }}>
              <Panel bordered>
                <h6 style={{ textAlign: 'center', marginBottom: '5px' }}>Profit Calculation</h6>
                <ControlRow2
                  label={'50 %'}
                  // label={fieldData?.overallcost}
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      value={`${((fieldData?.overallcost * 50) / 100).toFixed(2)}`}
                    />
                  }
                />
                <ControlRow2
                  label={'70 %'}
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      value={`${((fieldData?.overallcost * 70) / 100).toFixed(2)}`}
                    />
                  }
                />
                <ControlRow2
                  label={'80 %'}
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      value={`${((fieldData?.overallcost * 80) / 100).toFixed(2)}`}
                    />
                  }
                />
                <ControlRow2
                  label={'100 %'}
                  control={
                    <CustomInput
                      step={null}
                      id="custinputno"
                      value={`${((fieldData?.overallcost * 100) / 100).toFixed(2)}`}
                    />
                  }
                />
              </Panel>
            </Col>
            {/* <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="GST %"
                control={
                  <CustomInput
                    step={null}
                    name="gstper"
                    value={fieldData.gstper || ''}
                    onChange={value => {
                      const result = (+fieldData.overallcost * +value) / 100;
                      handleFieldDataValue('gstper', value);
                      handleFieldDataValue('gstcost', result.toFixed(2));
                      handleReload();
                    }}
                  />
                }
                control2={
                  <CustomInput
                    step={null}
                    name="gstcost"
                    value={fieldData.gstcost || ''}
                    onChange={value => {
                      const percentage = (+value / +fieldData.overallcost) * 100;
                      handleFieldDataValue('gstcost', value);
                      handleFieldDataValue('gstper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => {
                      handleFieldUpdate("GST", true);
                    }}
                    onBlur={() =>
                      handleFieldUpdate("GST", false)
                    }
                  />
                }
              />
            </Col> */}
            {/* <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Laison %"
                control={
                  <CustomInput
                    step={null}
                    name="laisonper"
                    value={fieldData.laisonper || ''}
                    onChange={value => {
                      const result = (value * fieldData.overallcost) / 100;
                      handleFieldDataValue('laisonper', value);
                      handleFieldDataValue('laisoncost', result.toFixed(2));
                      handleReload();
                    }}
                  />
                }
                control2={
                  <CustomInput
                    step={null}
                    name="laisoncost"
                    value={fieldData.laisoncost || ''}
                    onChange={value => {
                      const percentage = (value / +fieldData.overallcost) * 100;
                      handleFieldDataValue('laisoncost', value);
                      handleFieldDataValue('laisonper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => {
                      handleFieldUpdate("Laison", true);
                    }}
                    onBlur={() =>
                      handleFieldUpdate("Laison", false)
                    }
                  />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Testing %"
                control={
                  <CustomInput
                    step={null}
                    name="testingper"
                    value={fieldData.testingper}
                    onChange={value => {
                      const result = (+fieldData.overallcost * +value) / 100;
                      handleFieldDataValue('testingper', value);
                      handleFieldDataValue('testingcost', result.toFixed(2));
                      handleReload();
                    }}

                  />
                }
                control2={
                  <CustomInput
                    step={null}
                    name="testingcost"
                    value={fieldData.testingcost}
                    onChange={value => {
                      const percentage = (+value / +fieldData.overallcost) * 100;
                      handleFieldDataValue('testingcost', value);
                      handleFieldDataValue('testingper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => {
                      handleFieldUpdate("Testing", true);
                    }}
                    onBlur={() =>
                      handleFieldUpdate("Testing", false)
                    }
                  />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Other %"
                control={
                  <CustomInput
                    step={null}
                    name="otherper"
                    value={fieldData.otherper}
                    onChange={value => {
                      const result = (+fieldData.overallcost * +value) / 100;
                      handleFieldDataValue('otherper', value);
                      handleFieldDataValue('othercost', result.toFixed(2));
                      handleReload();
                    }}
                  />
                }
                control2={
                  <CustomInput
                    step={null}
                    name="othercost"
                    value={fieldData.othercost}
                    onChange={value => {
                      const percentage = (+value / +fieldData.overallcost) * 100;
                      handleFieldDataValue('othercost', value);
                      handleFieldDataValue('otherper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => {
                      handleFieldUpdate("Other", true);
                    }}
                    onBlur={() =>
                      handleFieldUpdate("Other", false)
                    }
                  />
                }
              />
            </Col> */}
            <Col xs={12} style={{ marginTop: '10px' }}></Col>
            <Col xs={12} style={{ marginTop: '10px' }}></Col>
            <Col xs={12} style={{ marginTop: '10px' }}></Col>
            {/* <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Misc"
                control={
                  <CustomInput
                    step={null}
                    name="miscper"
                    value={fieldData.miscper}
                    onChange={value => {
                      const result = (+fieldData.subtotalwohcost * +value) / 100;
                      handleFieldDataValue('miscper', value);
                      handleFieldDataValue('misccost', result.toFixed(2));
                      handleReload();
                    }}
                  />
                }
                control2={
                  <CustomInput
                    step={null}
                    name="misccost"
                    value={fieldData.misccost}
                    onChange={value => {
                      const percentage = (+value / +fieldData.subtotalcost) * 100;
                      handleFieldDataValue('misccost', value);
                      handleFieldDataValue('miscper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => {
                      handleFieldUpdate("Misc", true)
                    }}
                    onBlur={() =>
                      handleFieldUpdate("Misc", false)
                    }
                  />
                }
              />
            </Col> */}
          </Row>
        </Panel>
      </Col>
    );
  }
);
